import React from 'react'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Dropdown, Input, Button, Grid, Form, Select } from 'semantic-ui-react';
import { getSystemAdminClients } from '../../../actions'

const optionsSearchFilter = [
    { key: 'NAME', text: 'Name', value: 'NAME' },
    { key: 'NRIC', text: 'NRIC', value: 'NRIC' },
]

const optionStatusFilter = [
    { key: 'ALL', text: 'ALL STATUS', value: 'ALL' },
    { key: 'PROCESSING', text: 'PROCESSING', value: 'PROCESSING' },
    { key: 'SUBMITTED', text: 'SUBMITTED', value: 'SUBMITTED' },
    { key: 'DELETED', text: 'DELETED', value: 'DELETED' },
]

class InpatientListSearch extends React.Component {

    componentDidMount() {
        if (this.props.user.accessToken) {
            // Get claim data
            this.props.getSystemAdminClients(this.props.user.accessToken, () => { });
        }
    }

    getCompanySearchOption() {
        let options = [{ key: 'ALL', text: 'ALL COMPANY', value: 'ALL', "data-companydid": "ALL_COMPANY" }]
        if (this.props.clients) {
            for (let client of this.props.clients) {
                options.push({ key: client._id, text: client.name, value: client._id, "data-companydid": client._id })
            }
        }
        return options;
    }

    onSearch(event, data) {

        let urlSearch = new URLSearchParams(this.props.location.search);

        // set filter status
        let filterStatus = document.querySelector("div[name='searchFilterStatus'] *:first-child").innerHTML;
        if (!filterStatus || filterStatus === "ALL STATUS") {
            urlSearch.delete("claimStatus");
        } else {
            urlSearch.set("claimStatus", filterStatus);
        }

        // set filter company
        let filterCompany = document.querySelector("div[name='searchFilterCompany'] div[aria-checked='true']").dataset.companydid;
        if (!filterCompany || filterCompany === "ALL_COMPANY") {
            urlSearch.delete("companyId");
        } else {
            urlSearch.set("companyId", filterCompany);
        }

        // set filter name or nric
        let filterText = document.querySelector("input[name='inpatientFilterText']").value;
        if (filterText) {

            // get filter type
            let filterType = document.querySelector("#inpatientFilterType *:first-child");

            // set filter name
            if (filterType.innerHTML === "Name") {
                urlSearch.set("name", filterText);
            } else {
                urlSearch.delete("name");
            }

            // set filter nric
            if (filterType.innerHTML === "NRIC") {
                urlSearch.set("nric", filterText);
            } else {
                urlSearch.delete("nric");
            }

        } else {
            urlSearch.delete("name");
            urlSearch.delete("nric");
        }

        // Set filter page
        urlSearch.delete("searchPage");

        // Go to url
        this.props.history.push({
            pathname: this.props.history.location.pathname,
            search: urlSearch.toString()
        });

    }

    onClearSearch() {
        // Go to url
        this.props.history.push({ pathname: this.props.history.location.pathname });
    }

    onCompanyChange(event, data) {

        // Get query string
        let queryString = new URLSearchParams(this.props.location.search);

        // set value to filter company
        let companyId = data.value;
        if (!companyId || companyId === "ALL") {
            queryString.delete("companyId");
        } else {
            queryString.set("companyId", companyId);
        }

        // reset page
        queryString.delete("searchPage");

        // Go to url
        this.props.history.push({
            pathname: this.props.history.location.pathname,
            search: queryString.toString()
        });
    }

    onStatusChange(event, data) {
        // Get query string
        let queryString = new URLSearchParams(this.props.location.search);

        // set value to filter company
        let claimStatus = data.value;
        if (!claimStatus || claimStatus === "ALL") {
            queryString.delete("claimStatus");
        } else {
            queryString.set("claimStatus", claimStatus);
        }

        // reset page
        queryString.delete("searchPage");

        // Go to url
        this.props.history.push({
            pathname: this.props.history.location.pathname,
            search: queryString.toString()
        });
    }

    render() {

        // Get query string
        let urlSearch = new URLSearchParams(this.props.location.search);

        // get value for filter company
        let filterCompanyId = urlSearch.get("companyId");
        if (!filterCompanyId) filterCompanyId = 'ALL';

        // get value for filter claimStatus
        let filterClaimStatus = urlSearch.get("claimStatus");
        if (!filterClaimStatus) filterClaimStatus = 'PROCESSING';

        // get value for filter nric
        let filterNRIC = urlSearch.get("nric");

        // get search filter name
        let filterName = urlSearch.get("name");

        return (
            <>
                <Grid columns="equal">
                    <Grid.Column width={3}>
                        <Dropdown name="searchFilterStatus" fluid selection placeholder='Filter Status' options={optionStatusFilter} defaultValue={filterClaimStatus} onChange={this.onStatusChange.bind(this)} disabled={true} />
                    </Grid.Column>
                    <Grid.Column width={4}>
                        <Dropdown name="searchFilterCompany" fluid selection placeholder='Filter Company' options={this.getCompanySearchOption()} defaultValue={filterCompanyId} onChange={this.onCompanyChange.bind(this)} />
                    </Grid.Column>
                    <Grid.Column width={9}>
                        <>
                            <Input fluid type='text' placeholder='Search...' action>
                                <input name="inpatientFilterText" defaultValue={filterNRIC || filterName || undefined} />
                                <Dropdown id="inpatientFilterType" placeholder='Filter by' selection options={optionsSearchFilter}
                                    defaultValue={filterNRIC ? "NRIC" : "NAME"} />
                                <Button type="submit" color="green" icon="search" content="Search" onClick={this.onSearch.bind(this)} />
                                <Button type="button" color="black" icon="close" content="Clear" onClick={this.onClearSearch.bind(this)} />
                            </Input>
                        </>
                    </Grid.Column>
                </Grid>
            </>
        )
    }


}

const mapStateToProps = (state) => {
    return {
        user: state.user.user,
        claims: state.systemAdminClaims,
        clients: state.systemAdmin.clients,
    };
}

export default connect(mapStateToProps, {
    getSystemAdminClients,
})(withRouter(InpatientListSearch))